import React from "react";
import { useLocation, Link } from "react-router-dom";

// Cache-bust the hero image once at module load so users who had the old
// hero.png cached get the new file on next visit without manual refresh.
const HERO_CACHE_KEY = "2026-02-temple-blueprint-v3";

export default function Layout({ children }) {
    const heroUrl = `${process.env.PUBLIC_URL || ""}/hero.png?v=${HERO_CACHE_KEY}`;
    return (
        <div
            className="App codex-stage min-h-screen relative pb-10"
            style={{ "--codex-hero-bg": `url(${heroUrl})` }}
        >
            <div className="codex-hero-echo codex-hero-echo--left" aria-hidden />
            <div className="codex-hero-echo codex-hero-echo--right" aria-hidden />
            <div className="codex-side-glow" aria-hidden />
            <TopBar />
            <main className="relative z-10 px-4 sm:px-8 lg:px-14 max-w-5xl mx-auto pt-6 pb-16">
                {children}
            </main>
        </div>
    );
}

function TopBar() {
    return (
        <header
            className="relative z-20 mx-auto mt-3 sm:mt-4 rounded-2xl"
            data-testid="top-bar"
            style={{
                maxWidth: "min(1480px, calc(100% - 28px))",
                background:
                    "linear-gradient(180deg, rgba(5,8,19,0.55) 0%, rgba(7,16,31,0.45) 70%, rgba(10,20,38,0.35) 100%)",
                backdropFilter: "blur(8px) saturate(120%)",
                WebkitBackdropFilter: "blur(8px) saturate(120%)",
                border: "1px solid rgba(212,175,55,0.40)",
                boxShadow:
                    "0 22px 44px -26px rgba(0,0,0,0.65), inset 0 -1px 0 rgba(212,175,55,0.14)",
            }}
        >
            {/* faint gold scrollwork hairline above the divider */}
            <div
                aria-hidden
                className="absolute inset-x-0 -bottom-px h-px"
                style={{
                    background:
                        "linear-gradient(90deg, transparent 0%, rgba(212,175,55,0.0) 8%, rgba(212,175,55,0.85) 50%, rgba(212,175,55,0.0) 92%, transparent 100%)",
                }}
            />
            <div className="w-full px-4 sm:px-6 lg:px-10 text-center space-y-1 pt-3 sm:pt-4 pb-3 sm:pb-3.5">
                <h1
                    data-testid="brand-arc-title"
                    className="font-serif-display italic tracking-wide leading-[1.0]"
                >
                    <Link
                        to="/"
                        data-testid="brand-home-link"
                        aria-label="Return to The New Jerusalem Codex home"
                        className="inline-block transition-[filter,transform] duration-200 hover:[filter:brightness(1.12)_drop-shadow(0_0_22px_rgba(249,229,150,0.55))] hover:scale-[1.005]"
                        style={{
                            fontSize: "clamp(1.85rem, 5.4vw, 5.2rem)",
                            color: "#F9E596",
                            filter:
                                "drop-shadow(0 3px 14px rgba(0,0,0,0.85)) drop-shadow(0 0 18px rgba(212,175,55,0.30))",
                        }}
                    >
                        The New Jerusalem Codex
                    </Link>
                </h1>
                <p
                    data-testid="brand-arc-subtitle"
                    className="font-mono-os uppercase text-[#E9D27A] tracking-[0.55em] sm:tracking-[0.7em] leading-none"
                    style={{
                        fontSize: "clamp(0.78rem, 1.45vw, 1.15rem)",
                        textShadow: "0 1px 6px rgba(0,0,0,0.85)",
                    }}
                >
                    Theological Operating System
                </p>
            </div>
        </header>
    );
}
